import { createContext, useContext } from 'react'

import { Filter } from '@cubejs-client/core'

export type AccessFiltersType = {
  accessFilters: Filter[]
}

/**
 * Context that handles access filters for cube reporting pages.
 *
 * This is primarily used in the Chats report to provide limited access (only my conversations view).
 */
const CubeReportAccessFiltersContext = createContext<AccessFiltersType>({
  accessFilters: [],
})

export const useCubeReportAccessFiltersContext = () =>
  useContext(CubeReportAccessFiltersContext)

export default CubeReportAccessFiltersContext
